// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Chat Panel */
.chat-panel {
  display: flex;
  flex-direction: column;
  width: 350px;
  height: 100%;
  background-color: #16213e;
  border-left: 1px solid #0f3460;
  transition: all 0.3s ease;
}

/* Mode Panel (overlay) */
.chat-panel.panel-mode {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
}

/* Mode Page (normal) */
.chat-panel.page-mode {
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
}

/* Variant Meeting (compact) */
.chat-panel.meeting {
  width: 300px;
}

.chat-panel.meeting .chat-messages {
  padding: 8px;
}

.chat-panel.meeting .message {
  padding: 6px 10px;
  font-size: 13px;
}

.chat-panel.meeting .chat-input-form {
  padding: 8px;
}

.chat-panel.meeting .chat-files {
  max-height: 100px;
}

/* Variant Room (riche) */
.chat-panel.room {
  width: 380px;
}

.chat-panel.room .chat-header {
  padding: 20px 16px;
}

.chat-panel.room .chat-header h3 {
  font-size: 20px;
}

.chat-panel.room .chat-messages {
  padding: 20px;
  gap: 16px;
}

.chat-panel.room .message {
  padding: 12px 16px;
}

.chat-panel.room .chat-input-form {
  padding: 16px;
}

.chat-panel.room .chat-files {
  padding: 0 20px 16px;
  max-height: 200px;
}

/* Header */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #0f3460;
}

.chat-header h3 {
  margin: 0;
  font-size: 18px;
  color: #eaeaea;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: #eaeaea;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #0f3460;
}

/* Messages Container */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.no-messages {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #888;
  text-align: center;
}

.no-messages .hint {
  font-size: 14px;
  opacity: 0.7;
  margin-top: 4px;
}

/* Message Bubbles */
.message {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: 12px;
  word-wrap: break-word;
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.own {
  align-self: flex-end;
  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);
  color: white;
  border-bottom-right-radius: 4px;
}

.message.other {
  align-self: flex-start;
  background-color: #0f3460;
  color: #eaeaea;
  border-bottom-left-radius: 4px;
}

.message.system {
  align-self: center;
  background-color: transparent;
  color: #888;
  font-size: 12px;
  font-style: italic;
  padding: 4px 8px;
}

.message.compact {
  max-width: 90%;
  padding: 6px 10px;
  font-size: 13px;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  gap: 8px;
}

.sender-name {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.9;
}

.message-time {
  font-size: 10px;
  opacity: 0.7;
}

.message-content {
  font-size: 14px;
  line-height: 1.4;
}

/* Files Section */
.chat-files {
  padding: 0 16px;
  max-height: 150px;
  overflow-y: auto;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 8px;
}

.file-item {
  padding: 8px;
  background-color: #0f3460;
  border-radius: 8px;
}

.file-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #eaeaea;
  text-decoration: none;
  font-size: 13px;
}

.file-link:hover {
  color: #e94560;
}

.file-icon {
  font-size: 16px;
}

.file-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 11px;
  opacity: 0.7;
}

/* Input Form */
.chat-input-form {
  display: flex;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #0f3460;
}

.chat-input {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  border-radius: 24px;
  background-color: #0f3460;
  color: #eaeaea;
  font-size: 14px;
  outline: none;
  transition: box-shadow 0.2s;
}

.chat-input::placeholder {
  color: #888;
}

.chat-input:focus {
  box-shadow: 0 0 0 2px #e94560;
}

.send-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background-color: #e94560;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-btn:hover:not(:disabled) {
  background-color: #d63850;
  transform: scale(1.05);
}

.send-btn:disabled {
  background-color: #0f3460;
  cursor: not-allowed;
  opacity: 0.5;
}

.file-upload-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background-color: #0f3460;
  color: #eaeaea;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-upload-btn:hover {
  background-color: #1a4a7a;
}

/* Loading State */
.chat-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #888;
  font-style: italic;
}

/* Scrollbar Styling */
.chat-messages::-webkit-scrollbar,
.chat-files::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track,
.chat-files::-webkit-scrollbar-track {
  background: transparent;
}

.chat-messages::-webkit-scrollbar-thumb,
.chat-files::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover,
.chat-files::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .chat-panel.panel-mode {
    width: 100%;
    max-width: 350px;
  }

  .chat-panel.room {
    width: 100%;
    max-width: 380px;
  }

  .chat-header {
    padding: 14px;
  }

  .chat-header h3 {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .chat-panel.panel-mode,
  .chat-panel.room {
    max-width: 100%;
    width: 100%;
  }

  .chat-header {
    padding: 12px;
  }

  .chat-messages {
    padding: 12px;
  }

  .chat-input-form {
    padding: 12px;
  }

  .send-btn,
  .file-upload-btn {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .chat-input {
    padding: 10px 14px;
    font-size: 14px;
  }
}

/* Message Actions */
.message-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.message:hover .message-actions {
  opacity: 1;
}

.btn-icon.btn-edit-msg,
.btn-icon.btn-delete-msg {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-icon.btn-edit-msg:hover {
  color: #4a90e2;
  background-color: rgba(255, 255, 255, 0.1);
}

.btn-icon.btn-delete-msg:hover {
  color: #e94560;
  background-color: rgba(255, 255, 255, 0.1);
}

.message.other .btn-icon.btn-edit-msg,
.message.other .btn-icon.btn-delete-msg {
  color: rgba(234, 234, 234, 0.7);
}

/* Edited Indicator */
.edited-indicator {
  font-size: 11px;
  opacity: 0.7;
  margin-left: 4px;
  font-style: italic;
}

/* Edit Input */
.message-edit {
  margin-top: 8px;
}

.edit-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #0f3460;
  border-radius: 6px;
  background-color: #0f3460;
  color: #eaeaea;
  font-size: 14px;
  outline: none;
  margin-bottom: 6px;
}

.edit-input:focus {
  border-color: #e94560;
  box-shadow: 0 0 0 2px rgba(233, 69, 96, 0.2);
}

.edit-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn-cancel-edit,
.btn-save-edit {
  padding: 4px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel-edit {
  background-color: transparent;
  color: #888;
}

.btn-cancel-edit:hover {
  color: #eaeaea;
}

.btn-save-edit {
  background-color: #e94560;
  color: white;
}

.btn-save-edit:hover {
  background-color: #d63850;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Base Chat Panel */\n.chat-panel {\n  display: flex;\n  flex-direction: column;\n  width: 350px;\n  height: 100%;\n  background-color: #16213e;\n  border-left: 1px solid #0f3460;\n  transition: all 0.3s ease;\n}\n\n/* Mode Panel (overlay) */\n.chat-panel.panel-mode {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Mode Page (normal) */\n.chat-panel.page-mode {\n  height: 600px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* Variant Meeting (compact) */\n.chat-panel.meeting {\n  width: 300px;\n}\n\n.chat-panel.meeting .chat-messages {\n  padding: 8px;\n}\n\n.chat-panel.meeting .message {\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.chat-panel.meeting .chat-input-form {\n  padding: 8px;\n}\n\n.chat-panel.meeting .chat-files {\n  max-height: 100px;\n}\n\n/* Variant Room (riche) */\n.chat-panel.room {\n  width: 380px;\n}\n\n.chat-panel.room .chat-header {\n  padding: 20px 16px;\n}\n\n.chat-panel.room .chat-header h3 {\n  font-size: 20px;\n}\n\n.chat-panel.room .chat-messages {\n  padding: 20px;\n  gap: 16px;\n}\n\n.chat-panel.room .message {\n  padding: 12px 16px;\n}\n\n.chat-panel.room .chat-input-form {\n  padding: 16px;\n}\n\n.chat-panel.room .chat-files {\n  padding: 0 20px 16px;\n  max-height: 200px;\n}\n\n/* Header */\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #0f3460;\n}\n\n.chat-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #eaeaea;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #eaeaea;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.close-btn:hover {\n  background-color: #0f3460;\n}\n\n/* Messages Container */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.no-messages {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #888;\n  text-align: center;\n}\n\n.no-messages .hint {\n  font-size: 14px;\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n/* Message Bubbles */\n.message {\n  max-width: 85%;\n  padding: 10px 14px;\n  border-radius: 12px;\n  word-wrap: break-word;\n  animation: fadeIn 0.2s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message.own {\n  align-self: flex-end;\n  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.message.other {\n  align-self: flex-start;\n  background-color: #0f3460;\n  color: #eaeaea;\n  border-bottom-left-radius: 4px;\n}\n\n.message.system {\n  align-self: center;\n  background-color: transparent;\n  color: #888;\n  font-size: 12px;\n  font-style: italic;\n  padding: 4px 8px;\n}\n\n.message.compact {\n  max-width: 90%;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n  gap: 8px;\n}\n\n.sender-name {\n  font-size: 12px;\n  font-weight: 600;\n  opacity: 0.9;\n}\n\n.message-time {\n  font-size: 10px;\n  opacity: 0.7;\n}\n\n.message-content {\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Files Section */\n.chat-files {\n  padding: 0 16px;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 8px;\n}\n\n.file-item {\n  padding: 8px;\n  background-color: #0f3460;\n  border-radius: 8px;\n}\n\n.file-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #eaeaea;\n  text-decoration: none;\n  font-size: 13px;\n}\n\n.file-link:hover {\n  color: #e94560;\n}\n\n.file-icon {\n  font-size: 16px;\n}\n\n.file-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n/* Input Form */\n.chat-input-form {\n  display: flex;\n  gap: 8px;\n  padding: 16px;\n  border-top: 1px solid #0f3460;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 24px;\n  background-color: #0f3460;\n  color: #eaeaea;\n  font-size: 14px;\n  outline: none;\n  transition: box-shadow 0.2s;\n}\n\n.chat-input::placeholder {\n  color: #888;\n}\n\n.chat-input:focus {\n  box-shadow: 0 0 0 2px #e94560;\n}\n\n.send-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: 50%;\n  background-color: #e94560;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.send-btn:hover:not(:disabled) {\n  background-color: #d63850;\n  transform: scale(1.05);\n}\n\n.send-btn:disabled {\n  background-color: #0f3460;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.file-upload-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: 50%;\n  background-color: #0f3460;\n  color: #eaeaea;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-upload-btn:hover {\n  background-color: #1a4a7a;\n}\n\n/* Loading State */\n.chat-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #888;\n  font-style: italic;\n}\n\n/* Scrollbar Styling */\n.chat-messages::-webkit-scrollbar,\n.chat-files::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-messages::-webkit-scrollbar-track,\n.chat-files::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-messages::-webkit-scrollbar-thumb,\n.chat-files::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover,\n.chat-files::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chat-panel.panel-mode {\n    width: 100%;\n    max-width: 350px;\n  }\n\n  .chat-panel.room {\n    width: 100%;\n    max-width: 380px;\n  }\n\n  .chat-header {\n    padding: 14px;\n  }\n\n  .chat-header h3 {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-panel.panel-mode,\n  .chat-panel.room {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .chat-header {\n    padding: 12px;\n  }\n\n  .chat-messages {\n    padding: 12px;\n  }\n\n  .chat-input-form {\n    padding: 12px;\n  }\n\n  .send-btn,\n  .file-upload-btn {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n\n  .chat-input {\n    padding: 10px 14px;\n    font-size: 14px;\n  }\n}\n\n/* Message Actions */\n.message-actions {\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.message:hover .message-actions {\n  opacity: 1;\n}\n\n.btn-icon.btn-edit-msg,\n.btn-icon.btn-delete-msg {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.btn-icon.btn-edit-msg:hover {\n  color: #4a90e2;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.btn-icon.btn-delete-msg:hover {\n  color: #e94560;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.message.other .btn-icon.btn-edit-msg,\n.message.other .btn-icon.btn-delete-msg {\n  color: rgba(234, 234, 234, 0.7);\n}\n\n/* Edited Indicator */\n.edited-indicator {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-left: 4px;\n  font-style: italic;\n}\n\n/* Edit Input */\n.message-edit {\n  margin-top: 8px;\n}\n\n.edit-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #0f3460;\n  border-radius: 6px;\n  background-color: #0f3460;\n  color: #eaeaea;\n  font-size: 14px;\n  outline: none;\n  margin-bottom: 6px;\n}\n\n.edit-input:focus {\n  border-color: #e94560;\n  box-shadow: 0 0 0 2px rgba(233, 69, 96, 0.2);\n}\n\n.edit-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.btn-cancel-edit,\n.btn-save-edit {\n  padding: 4px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-cancel-edit {\n  background-color: transparent;\n  color: #888;\n}\n\n.btn-cancel-edit:hover {\n  color: #eaeaea;\n}\n\n.btn-save-edit {\n  background-color: #e94560;\n  color: white;\n}\n\n.btn-save-edit:hover {\n  background-color: #d63850;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
